var _g, _g2, _g3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNegative(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100px",
    height: "100px",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 10.5C9.82843 10.5 10.5 9.82843 10.5 9C10.5 8.17157 9.82843 7.5 9 7.5C8.17157 7.5 7.5 8.17157 7.5 9C7.5 9.82843 8.17157 10.5 9 10.5Z",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 10.5C15.8284 10.5 16.5 9.82843 16.5 9C16.5 8.17157 15.8284 7.5 15 7.5C14.1716 7.5 13.5 8.17157 13.5 9C13.5 9.82843 14.1716 10.5 15 10.5Z",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.79678 16.6041C8.4646 17.0423 7.84036 17.1303 7.39992 16.7999C6.96219 16.4716 6.87354 15.8336 7.20208 15.3971C7.30914 15.2557 7.42882 15.1234 7.55137 14.9955C7.76344 14.7742 8.07335 14.4828 8.47425 14.1912C9.27219 13.6109 10.4744 12.9999 11.9999 12.9999C13.5254 12.9999 14.7277 13.6109 15.5256 14.1912C15.9265 14.4828 16.2364 14.7742 16.4485 14.9955C16.5714 15.1238 16.6918 15.2565 16.7989 15.3986L16.7999 15.3999C17.1313 15.8418 17.0417 16.4686 16.5999 16.7999C16.1595 17.1303 15.5352 17.0423 15.2031 16.6041L15.1984 16.5982C15.1925 16.5907 15.1812 16.5766 15.1646 16.5569C15.1315 16.5174 15.0777 16.4558 15.0045 16.3793C14.8572 16.2256 14.6359 16.0171 14.3492 15.8087C13.7722 15.389 12.9744 14.9999 11.9999 14.9999C11.0254 14.9999 10.2277 15.389 9.65059 15.8087C9.36399 16.0171 9.14264 16.2256 8.99535 16.3793C8.92211 16.4558 8.86838 16.5174 8.83523 16.5569C8.81869 16.5766 8.80737 16.5907 8.80142 16.5982L8.79678 16.6041Z",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 1C5.92487 1 1 5.92487 1 12C1 18.0751 5.92487 23 12 23C18.0751 23 23 18.0751 23 12C23 5.92487 18.0751 1 12 1ZM3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12Z",
    fill: "#000000"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNegative);
export default __webpack_public_path__ + "static/media/negative.c023714d61bcda5399b310c9114d140c.svg";
export { ForwardRef as ReactComponent };